/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import useStyle from './Container.style';
import { css, SerializedStyles } from '@emotion/react';
import { UICoreColor, UICoreSize } from '@shared/react-ui-core/theme';

type SectionProps = React.DetailedHTMLProps<
  React.HtmlHTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export type ContainerProps = {
  children: React.ReactNode;
  className?: string;
  bg?: UICoreColor;
  size?: UICoreSize;
  color?: UICoreColor;
  noPadding?: boolean;
  css?: SerializedStyles;
} & SectionProps;

const Container: FC<ContainerProps> = ({
  children,
  className,
  bg = 'transparent',
  size = 'wide',
  noPadding = false,
  color = 'dark',
  css: cssProp,
  ...props
}) => {
  const s = useStyle();
  return (
    <section
      css={css(
        s.container,
        s.setBg(bg),
        s.setColor(color),
        s.setWidth(size),
        s.setNoPadding(noPadding),
        cssProp
      )}
      className={className}
      {...props}
    >
      {children}
    </section>
  );
};

export default Container;
